var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-578-945H864V79H-578z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-577-15H865v94H-577z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30-3H70v70H-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M20 23.333a4.978 4.978 0 004.983-5l.017-10c0-2.766-2.233-5-5-5s-5 2.234-5 5v10c0 2.767 2.233 5 5 5zm8.833-5c0 5-4.233 8.5-8.833 8.5-4.6 0-8.833-3.5-8.833-8.5H8.333c0 5.684 4.534 10.384 10 11.2V35h3.334v-5.467c5.466-.8 10-5.5 10-11.2h-2.834z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioActive);
export default __webpack_public_path__ + "static/media/audio-active.b81cf104063f0b66ef6c460388683678.svg";
export { ForwardRef as ReactComponent };